import { selectionSteps, STEPS } from '@/redux/ducks/upgrade/wizard'
import type { StepType } from '../hooks/useUpgradeSteps'

// the three steps the customer sees - the plan selection of several products is bundled into "Plan"
export const VISIBLE_STEPS = ['selection', STEPS.EXTENSIONS, STEPS.BILLING] as const
export type VisibleStep = typeof VISIBLE_STEPS[number]

/**
 * Index of the visible step (0 = Plan, 1 = Add-ons, 2 = Daten & Zahlung) for the active wizard step.
 * Entry points that start with a plan already in the cart skip "Plan", which is then shown as done.
 */
const getVisibleStepIndex = (activeStep: StepType | null): number => {
  if (!activeStep || selectionSteps.includes(activeStep)) return 0
  const index = VISIBLE_STEPS.indexOf(activeStep as VisibleStep)
  return index >= 0 ? index : 0
}

export default getVisibleStepIndex
